import { OPERATIONS_API_BASE } from '../../config/api';
import React from 'react';
import CameraCapture from '../../components/CameraCapture';

export default function camera({ route, navigation }) {
  const { iditem, tipo, fotoSeq, typeComp } = route.params;

  async function updateItem(URL) {
    let query = '';

    if (tipo == 'comp') {
      if (typeComp === 0) {
        query = `${OPERATIONS_API_BASE}/checklistcompitem/` + iditem;
      } else {
        query = `${OPERATIONS_API_BASE}/checklistcompitemexit/` + iditem;
      }
    } else if (tipo == 'rack') {
      query = 'https://superfrio-back-dev.vercel.app/checklistrackitem/' + iditem;
    } else {
      query = 'https://superfrio-back-dev.vercel.app/checklistpititem/' + iditem;
    }

    const responseApi = await fetch(query, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ foto: URL }),
    });

    const data = await responseApi.json();

    if (responseApi.ok) {
      route.params.refresh();
      navigation.goBack(null);
    } else {
      alert('error ' + data);
    }
  }

  return (
    <CameraCapture
      navigation={navigation}
      fileName={iditem + '_' + fotoSeq}
      onUploaded={updateItem}
    />
  );
}
